import { useAssignee, useOwners } from "PFApp/hooks/activity_commons/participants";
import { Stack } from "PFComponents/containers";
import { ProfilesAvatarStack } from "PFComponents/profile_avatar/profiles_avatar_stack";
import { Typography } from "PFComponents/typography";
import { Activity } from "PFTypes";
import { useTranslation } from "react-i18next";

type ActivityDetailsParticipantsProps = {
  activity?: Activity;
  handleAvatarClick?: ({ id }: { id: number }) => void;
};

export const ActivityDetailsParticipants = ({
  activity,
  handleAvatarClick
}: ActivityDetailsParticipantsProps) => {
  const { t } = useTranslation();
  const { owners, canView: canViewOwners } = useOwners(activity);
  const { assignee, canView: canViewAssignee } = useAssignee(activity);

  if (!canViewOwners && !canViewAssignee) {
    return null;
  }

  return (
    <Stack gap="spacingMd">
      {canViewOwners && (
        <Stack gap="spacingXs">
          <Typography withMargin variant="bodyBold">
            {t("owner_other")}
          </Typography>
          <ProfilesAvatarStack
            avatarSize={40}
            max={10}
            profiles={owners}
            handleAvatarClick={handleAvatarClick}
          />
        </Stack>
      )}
      {canViewAssignee && (
        <Stack gap="spacingXs">
          <Typography withMargin variant="bodyBold">
            {t("assignee")}
          </Typography>
          <ProfilesAvatarStack
            avatarSize={40}
            max={10}
            profiles={[assignee!]}
            handleAvatarClick={handleAvatarClick}
          />
        </Stack>
      )}
    </Stack>
  );
};
